export enum DeviceAlertType {
  Unknown = 'Unknown',
  DeviceOffline = 'DeviceOffline',
  BatteryLow = 'BatteryLow',
  BatteryCritical = 'BatteryCritical',
  BatteryEmpty = 'BatteryEmpty',
  IS32UnitError = 'IS32UnitError',
  IS32LocalbusError = 'IS32LocalbusError',
  IS32Error = 'IS32Error',
}
